import * as React from "react";

import { UILocation } from "@1js/acui-common";
import { AppFontStylesPreviewGalleryProps } from "@1js/acui-gallery-font-styles";
import { AppIcons } from "@1js/acui-icons";
import { ControlInMenuRendererFunction } from "@1js/acui-menu";

import { RibbonFontStylesPreviewGallery } from "../Controls/RibbonGallery";
import { convertRibbonPreviewGalleryToFlyoutAnchorProps } from "../Controls/RibbonGallery/";
import { getDefaultRibbonFlyoutAnchorRenderer } from "./getDefaultRibbonFlyoutAnchorRenderer";

export function getDefaultFontStylesPreviewGalleryRenderer(
  appIcons: AppIcons,
  controlInMenuRendererFunction: ControlInMenuRendererFunction
) {
  return (props: AppFontStylesPreviewGalleryProps) => {
    if (props.renderAsFlyout) {
      return getDefaultRibbonFlyoutAnchorRenderer(
        appIcons,
        controlInMenuRendererFunction
      )(convertRibbonPreviewGalleryToFlyoutAnchorProps(props));
    }

    return (
      <RibbonFontStylesPreviewGallery
        {...props}
        controlInMenuRendererFunction={controlInMenuRendererFunction}
        downChevronIcon={appIcons.downChevron}
        location={props.location || UILocation.Ribbon}
      />
    );
  };
}
